<template>
    <div class="mb-8 space-y-2 max-w-7xl mx-auto">
        <div class="flex items-center justify-between bg-gray-50 py-2 px-3">
            <h4 class="text-lg text-center font-medium">{{ $t('Users') }}</h4>
        </div>
        <UserSearch />
        <div class="px-4 py-3 border-b flex items-center space-x-3">
            <span class="text-sm font-medium">{{ $t('Filter by Group') }}</span>
            <a-select
                :disabled="loading"
                v-model="group"
                style="max-width: 220px"
                class="w-full"
                @change="handleChange"
            >
                <a-select-option value="">
                    {{ $t('No Filter') }}
                </a-select-option>
                <a-select-option :key="g.id" v-for="g in allGroups" :value="g.id">
                    {{ g.tag }}
                </a-select-option>
            </a-select>
            <span class="text-sm font-medium">{{ $t('Filter by Giv Type') }}</span>
            <a-select
                :disabled="loading"
                v-model="givType"
                style="max-width: 220px"
                class="w-full"
                @change="handleChange"
            >
                <a-select-option value="">
                    {{ $t('No Filter') }}
                </a-select-option>
                <a-select-option :key="g.id" v-for="g in allGivTypes" :value="g.id">
                    {{ g.tag }}
                </a-select-option>
            </a-select>
        </div>
        <ul class="space-y-1">
            <li v-for="user in users" :key="user.id">
                <UserCard :user="user" />
            </li>
        </ul>
        <spinner v-if="loading" />
        <div v-else>
            <div v-if="hasMore" class="flex justify-center">
                <button
                    @click="showMore"
                    class="border flex justify-center items-center h-10 w-40 border-gray-400 hover:border-gray-800 text-sm rounded px-3 py-2"
                >
                    <spinner v-if="loadingMore" class="text-white" />
                    <span v-else>{{ $t('Load More') }}</span>
                </button>
            </div>
            <div v-else class="flex justify-center">
                <span>{{ $t('No more items to show') }}</span>
            </div>
        </div>
    </div>
</template>
<script>
import api from '../lib/api'
import UserCard from '../components/UserCard'
import UserSearch from '../components/UserSearch'
export default {
    components: {
        UserCard,
        UserSearch,
    },
    data() {
        return {
            allGroups: [],
            allGivTypes: [],
            group: '',
            givType: '',
            users: [],
            loading: true,
            loadingMore: false,
            limit: 20,
            offset: 0,
            hasMore: true,
        }
    },
    async mounted() {
        if (this.$route.query.reload === true) {
            this.$router.push('/users')
        }
        this.allGroups = await api.getGroups()
        this.allGivTypes = await api.getGivTypes()
        const [users, newOffset] = await api.getUsers({ limit: this.limit })
        this.users = users
        this.offset = newOffset
        this.loading = false
        this.hasMore = users.length >= this.limit
    },
    methods: {
        async searchUsers() {
            this.loading = true
            this.users = []
            this.offset = null
            const [users, newOffset] = await api.getUsers({
                limit: this.limit,
                offset: this.offset,
                group: this.group,
                givType: this.givType,
            })
            this.users = users
            this.offset = newOffset
            this.loading = false
            this.hasMore = users.length >= this.limit
        },
        handleChange() {
            this.searchUsers()
        },
        async showMore() {
            this.loadingMore = true
            const [moreUsers, newOffset] = await api.getUsers({
                limit: this.limit,
                offset: this.offset,
                group: this.group,
                givType: this.givType,
            })
            this.users = [...this.users, ...moreUsers]
            this.offset = newOffset
            this.loadingMore = false
            this.hasMore = moreUsers.length >= this.limit
        },
    },
}
</script>
